import { css } from 'emotion';
import React, { Fragment } from 'react';
import TextInput from '../../textInput/TextInput';
import { useTheme } from '../../theme-context';

interface IHoldLine {
    info: {
        id: string;
        name: string;
        soldQuantity: string;
        heldQuantity: string;
    };
    onHeldQuantityChange: (id: string, quantity: string) => void;
}

const HoldLine = ({
    info,
    onHeldQuantityChange,
}: IHoldLine): React.ReactElement => {
    const { id, name, soldQuantity, heldQuantity } = info;
    const { getFont } = useTheme();

    return (
        <Fragment>
            <div
                data-testid="hold-name"
                className={css({
                    fontFamily: getFont('desktop/body/medium').fontFamily,
                    fontWeight: getFont('desktop/body/medium').fontWeight,
                    fontSize: getFont('desktop/body/medium').fontSize,
                    padding: '20px 16px 26px 16px',
                })}
            >
                {name}
            </div>
            <div
                data-testid="sold-quantity"
                className={css({
                    fontFamily: getFont('desktop/body/medium').fontFamily,
                    fontWeight: getFont('desktop/body/medium').fontWeight,
                    fontSize: getFont('desktop/body/medium').fontSize,
                    padding: '20px 16px 26px 16px',
                })}
            >
                {soldQuantity}
            </div>
            <div
                data-testid="held-quantity"
                className={css({
                    fontFamily: getFont('desktop/body/medium').fontFamily,
                    fontWeight: getFont('desktop/body/medium').fontWeight,
                    fontSize: getFont('desktop/body/medium').fontSize,
                    padding: '8px 24px 8px 16px',
                })}
            >
                <TextInput
                    value={heldQuantity}
                    onChange={(value) => onHeldQuantityChange(id, value)}
                />
            </div>
        </Fragment>
    );
};

export default HoldLine;
